// extracted by css-extract-rspack-plugin
export default {"section":"_ddfe74e0","content":"_16845740","isPreview":"_e5c0a2b9","gridItem":"_8e69ec84","footer":"_f7aab3ac","shimmerLoadingBackground":"_3bdbaa04"};